export default "__VITE_ASSET__R5xpw3M6__"